import { render, staticRenderFns } from "./LineGiftNew.vue?vue&type=template&id=3d06736e&scoped=true&"
import script from "./LineGiftNew.vue?vue&type=script&lang=js&"
export * from "./LineGiftNew.vue?vue&type=script&lang=js&"
import style0 from "./LineGiftNew.vue?vue&type=style&index=0&id=3d06736e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d06736e",
  null
  
)

export default component.exports